import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

export type EventqBooleanToggleVariant = 'default' | 'amber-dark';

@Component({
  selector: 'eventq-boolean-toggle',
  templateUrl: './boolean-toggle.html',
  styleUrl: './boolean-toggle.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.eventq-boolean-toggle-host--amber-dark]': "variant() === 'amber-dark'",
    '[class.eventq-boolean-toggle-host--disabled]': 'disabled()',
  },
})
export class EventqBooleanToggle {
  readonly label = input('Toggle Control');
  readonly variant = input<EventqBooleanToggleVariant>('default');
  readonly checked = input(false);
  readonly disabled = input(false);
  /** When false, only the switch renders (parent supplies visible text). */
  readonly showLabel = input(true);
  readonly checkedChange = output<boolean>();

  requestToggle(): void {
    if (this.disabled()) {
      return;
    }
    this.checkedChange.emit(!this.checked());
  }
}
